import _extends from "@babel/runtime/helpers/esm/extends";
import { close } from '@wordpress/icons';
import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { Button } from '../Button';

function CloseButton(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'CloseButton'),
      otherProps = _extends({}, _useContextSystem);

  return /*#__PURE__*/React.createElement(Button, Object.assign({
    icon: close,
    iconSize: 12,
    isSubtle: true,
    variant: "tertiary"
  }, otherProps, {
    ref: forwardedRef
  }));
}

export default contextConnect(CloseButton, 'CloseButton');